(() => {
    const rank = (profiles, answers) => profiles
    .map(profile => ({ profile, tie: Math.random() }))
    .map(({ profile, tie }) => {
    const formats = ['candle', 'spray'].filter(type => profile.products[type] && (answers.type === 'either' || answers.type === type));
    const matched = answers.families.filter(family => profile.families.includes(family));
    const primary = matched.includes(profile.families[0]);
    const mood = profile.moods.includes(answers.mood);
    const strength = profile.strength === answers.strength;
    return { profile, tie, formats, matched, mood, strength, score: (primary ? 20 : 10) + Math.min(matched.length - 1, 2) * 3 + (mood ? 3 : 0) + (strength ? 2 : 0) };
  }).filter(match => match.formats.length && match.matched.length).sort((a, b) => b.score - a.score || a.tie - b.tie).slice(0, 3);
  globalThis.LitScentRank = rank;
  if (typeof document === 'undefined') return;
  class LitScentFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.step = 0;
      this.copy = Object.fromEntries([...this.querySelectorAll('[data-key]')].map(node => [node.dataset.key, node.textContent]));
      this.profiles = [...this.querySelectorAll('[data-profile]')].map(node => ({
        name: node.dataset.name, notes: node.dataset.notes,
        families: node.dataset.families.split(',').map(v => v.trim().toLowerCase()).filter(Boolean),
        moods: node.dataset.moods.split(',').map(v => v.trim().toLowerCase()).filter(Boolean),
        strength: node.dataset.strength,
        products: Object.fromEntries([...node.querySelectorAll('[data-product]')].map(link => [link.dataset.product, { url: link.getAttribute('href'), title: link.dataset.title, image: link.querySelector('img') }]))
      }));
      this.querySelector('[data-start]').hidden = false;
      this.querySelector('[data-start]').addEventListener('click', () => {
        this.querySelector('[data-welcome]').hidden = true;
        this.querySelector('[data-quiz]').hidden = false;
        this.showStep();
      });
      this.querySelector('[data-back]').addEventListener('click', () => { this.step--; this.showStep(); });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.querySelector('form').reset();
        this.step = 0;
        this.querySelector('[data-results]').hidden = true;
        this.querySelector('[data-quiz]').hidden = false;
        this.showStep();
      });
      this.querySelector('form').addEventListener('change', () => { this.querySelector('[data-error]').hidden = true; });
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        const current = this.querySelector(`[data-step="${this.step}"]`);
        if (!current.querySelector('input:checked')) {
          this.querySelector('[data-error]').hidden = false;
          current.querySelector('input').focus();
          return;
        }
        if (this.step < 3) { this.step++; this.showStep(); } else this.showResults();
      });
    }
    showStep() {
      this.querySelectorAll('[data-step]').forEach((node, index) => { node.hidden = index !== this.step; });
      this.querySelector('[data-error]').hidden = true;
      this.querySelector('[data-back]').hidden = this.step === 0;
      this.querySelector('[data-next]').textContent = this.copy[this.step === 3 ? 'submit' : 'next'];
      const progress = this.copy.progress.replace('__NUMBER__', this.step + 1);
      this.querySelector('[data-progress]').textContent = progress;
      this.querySelector('progress').value = this.step + 1;
      this.querySelector('progress').setAttribute('aria-label', progress);
      this.querySelector(`[data-step="${this.step}"] legend`).focus();
    }
    showResults() {
      const selected = index => [...this.querySelectorAll(`[data-step="${index}"] input:checked`)].map(input => input.value);
      const answers = { families: selected(0), mood: selected(1)[0], strength: selected(2)[0], type: selected(3)[0] };
      const matches = rank(this.profiles, answers);
      const cards = this.querySelector('[data-cards]');
      cards.replaceChildren();
      this.querySelector('[data-summary]').textContent = [...answers.families, answers.mood, answers.strength, answers.type].map(v => this.copy['option_' + v]).join(' · ');
      const add = (parent, tag, value, className) => {
        const node = document.createElement(tag);
        if (value) node.textContent = value;
        if (className) node.className = className;
        parent.append(node);
        return node;
      };
      for (const match of matches) {
        const p = match.profile;
        const card = add(cards, 'article', '', 'lsf-card');
        const chosen = p.products[match.formats[0]];
        if (chosen.image) card.append(chosen.image.cloneNode(true));
        add(card, 'h3', p.name);
        add(card, 'p', this.copy.notes + ': ' + p.notes);
        add(card, 'small', this.copy.strength_label + ': ' + this.copy['option_' + p.strength]);
        let reason = this.copy[match.strength ? (match.mood ? 'reason_mood' : 'reason') : 'reason_other'];
        reason = reason.replace('__FAMILIES__', match.matched.map(v => this.copy['option_' + v].toLowerCase()).join(', ')).replace('__MOOD__', this.copy['option_' + answers.mood].toLowerCase()).replace('__STRENGTH__', this.copy['option_' + p.strength].toLowerCase());
        add(card, 'p', reason);
        for (const type of match.formats) {
          const product = p.products[type];
          const title = add(card, 'small', product.title);
          title.className = 'lsf-product-title';
          const link = add(card, 'a', this.copy[type], 'lsf-link');
          link.href = product.url;
          link.setAttribute('aria-label', this.copy[type] + ': ' + product.title);
        }
      }
      this.querySelector('[data-empty]').hidden = matches.length !== 0;
      this.querySelector('[data-quiz]').hidden = true;
      this.querySelector('[data-results]').hidden = false;
      this.querySelector('[data-results] h2').focus();
    }
  }
  if (!customElements.get('lit-scent-finder')) customElements.define('lit-scent-finder', LitScentFinder);
})();
